$(document).ready(function () {
  $(document).on('click', '#addToCartButtonId', function(e) {
    e.preventDefault();
    var addToCartButton = $(this);
    addToCartButton.addClass('loading'); // Add loading class to show loading indicator

    var response = [];
    var mainProductId = $('.main-product-input').val(); 
    var mainProductQuantity = $('.quantity-input-field').val();

    response.push({ id: mainProductId, quantity: mainProductQuantity });

    $('.addon-checkbox:checked').each(function () {
      var variantId = $(this).data('variant-id');
      var variantQuantity = 1; 
      response.push({ id: variantId, quantity: variantQuantity });
    });

    addToCart(response, addToCartButton);
  });
});

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.minicart = document.querySelector('mini-cart');
      this.eventContext = this.form.dataset.eventContext;
      this.hideErrors = this.dataset.hideErrors === 'true';

    }

    onSubmitHandler(event) {
      event.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) {
        return;
      }

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.button-overlay-spinner').classList.remove('hidden');

      const formData = new FormData(this.form);
      const response = [{ id: formData.get('id'), quantity: formData.get('quantity') }];
      addToCart(response, submitButton);
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) {
        return;
      }

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form-error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form-error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function addToCart(response, button) {
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: { items: response },
    success: function (data) {
      document.querySelector('mini-cart').updateSectionContents();
      console.log('Cart Items:', data);
      $('#cart-drawer').load(location.href + "/cart #cart-drawer", function() {
        console.log('cart refreshed'); 
        if (window.themeSettings.redirectToCart) {
          location.href = '/cart';
        } else {
          document.querySelector('mini-cart').open();
        }
      });                   
    },
    error: function (xhr, status, error) {
      console.error('Ajax Error:', status, error);
    },
    complete: function () {
      if (button) {
        button.removeClass('loading'); // Remove loading class after AJAX request completes
        button.removeAttr('aria-disabled');
        button.siblings('.button-overlay-spinner').addClass('hidden');
      }
    }
  })
  .fail(function(jqXHR, textStatus, errorThrown) {
    console.error(errorThrown);
  });
}
